import React from 'react';
import { ControlsWrapper } from '../styled';
import { Space } from 'antd';
import { tid } from '@utils/test';

// placeholder for dimension panel specific controls
const DimensionControls = () => {

  return (
    <ControlsWrapper {...tid('controls')}>
        <Space style={{ justifyContent: 'right', marginTop: 0 }}>

        </Space>
    </ControlsWrapper>
  );
};

export default DimensionControls;
